/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ speakerName: NonNullable<unknown> }} Speakers_Add_Recipient_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Add {speakerName} as recipient" |
*
* @param {Speakers_Add_Recipient_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_add_recipient_aria_label = /** @type {((inputs: Speakers_Add_Recipient_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Add_Recipient_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ajouter ${i?.speakerName} en tant que destinataire`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Füge ${i?.speakerName} als Empfänger hinzu`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Aggiungi ${i?.speakerName} come destinatario`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Добавить ${i?.speakerName} в качестве получателя`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Agregar ${i?.speakerName} como destinatario`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`添加 ${i?.speakerName} 为收件人`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.speakerName} を受信者として追加`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.speakerName} को प्राप्तकर्ता के रूप में जोड़ें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Adicionar ${i?.speakerName} como destinatário`)
	return /** @type {LocalizedString} */ (`Add ${i?.speakerName} as recipient`)
});